<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  class={$$props.class}
>
  <path
    d="M22.2081 2.45514C22.0919 2.3548 21.9505 2.28806 21.7992 2.26213C21.6479 2.23619 21.4923 2.25203 21.3494 2.30795L2.34998 9.74327C2.08071 9.84797 1.85275 10.0373 1.70041 10.2828C1.54806 10.5283 1.47959 10.8166 1.50529 11.1043C1.53098 11.3921 1.64947 11.6637 1.8429 11.8783C2.03633 12.0929 2.29423 12.2389 2.57779 12.2942L7.5006 13.2608V18.7498C7.49963 19.0488 7.58848 19.3412 7.75564 19.5891C7.9228 19.837 8.16056 20.029 8.4381 20.1401C8.71522 20.2533 9.01997 20.2805 9.31274 20.2181C9.6055 20.1557 9.87272 20.0067 10.0797 19.7905L12.4534 17.3286L16.2194 20.6248C16.4911 20.8658 16.8415 20.9992 17.2047 20.9998C17.3638 20.9997 17.522 20.9747 17.6734 20.9258C17.9209 20.8472 18.1434 20.7053 18.3189 20.514C18.4944 20.3227 18.6168 20.0887 18.6737 19.8355L22.479 3.28108C22.5131 3.13178 22.5058 2.97603 22.4581 2.83053C22.4104 2.68503 22.324 2.55527 22.2081 2.45514ZM17.2065 19.4998L9.45529 12.703L20.6115 4.70702L17.2065 19.4998Z"
    fill="currentColor"
  />
</svg>
